export const NEW_TAB_DOMAIN = process.env.REACT_APP_NEW_TAB_DOMAIN;
export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
export const FIREBASE_DOMAIN = process.env.REACT_APP_FIREBASE_DOMAIN;
export const VERSION = process.env.ADMIN_PANEL_VERSION;
export const SENTRY_DNS = process.env.REACT_APP_SENTRY_DNS;

